import { type Message } from '@analytical-alley/opt-wasm';
import { Alert, Typography } from '@analytical-alley/ui';
import {
    AiOutlineAlert,
    AiOutlineCheckCircle,
    AiOutlineInfoCircle,
    AiOutlineWarning,
} from 'react-icons/ai';

const getColor = (message: Message) => {
    switch (message.messageLevel) {
        case 'ERROR':
            return 'failure';
        case 'WARNING':
            return 'warning';
        case 'INFO':
            return 'info';
        case 'SUCCESS':
            return 'success';
        default:
            return 'dark';
    }
};

const getIcon = (message: Message) => {
    switch (message.messageLevel) {
        case 'ERROR':
            return AiOutlineAlert;
        case 'WARNING':
            return AiOutlineWarning;
        case 'INFO':
            return AiOutlineInfoCircle;
        case 'SUCCESS':
            return AiOutlineCheckCircle;
        default:
            return AiOutlineInfoCircle;
    }
};

const replaceProjectLeadEmail = (message: string, projectLeadEmail: string) => {
    return message.replace('e-mail', projectLeadEmail);
};

interface Props {
    messages: Message[];
    onDismiss: () => void;
    projectLeadEmail?: string;
}

export const Messages = ({ messages, onDismiss, projectLeadEmail }: Props) => {
    const displayMessages = messages.filter(
        (message) => message.messageLevel === 'ERROR',
    );

    return (
        <div className="flex flex-col gap-4 w-full mb-4">
            {displayMessages.map((message, index) => (
                <Alert
                    key={`${index}-${message.timestamp}-message`}
                    color={getColor(message)}
                    icon={getIcon(message)}
                    onDismiss={onDismiss}
                    withBorderAccent
                >
                    <Typography
                        variant="bodyM"
                        className="pl-2"
                        color="inherit"
                    >
                        {projectLeadEmail
                            ? replaceProjectLeadEmail(
                                  message.message,
                                  projectLeadEmail,
                              )
                            : message.message}
                    </Typography>
                    <Typography
                        variant="bodyXS"
                        className="pl-2"
                        color="inherit"
                    >
                        {message?.code ? `Code: ${message.code}` : ''}
                    </Typography>
                </Alert>
            ))}
        </div>
    );
};
